import React from 'react';
import { observer } from 'mobx-react-lite';
import WorkspaceFilter from './WorkspaceFilter/WorkspaceFilter';
import AllFilter from './AllFilter/AllFilter';
import DurationFilter from './DurationFilter/DurationFilter';
import MobileFilter from './MobileFilter/MobileFilter';
import ViewToggle from './ViewToggle/ViewToggle';
import styles from './FiltersPanel.module.scss';
import BudgetFilter from './BudgetFilter/BudgetFilter';
import { viewStore } from 'stores/ViewStore';
import { screenStore } from 'stores/ScreenStore';

interface Props {
  handleDurationSelection: (index: number) => void,
  spaceCount: number,
  fetchData: Function,
  onWorkspaceHandler: any;
}

const FiltersPanel: React.FC<Props> = ({
  handleDurationSelection,
  fetchData,
  onWorkspaceHandler
}: Props) => {
  const {view} = viewStore;
  const {isLaptopL} = screenStore;

  return (
    <div className={styles.container} id="filters_container">
      <div className={styles.container__options}>
        <div className={styles.container__options__filters}>
          {view == 'list' || (view == 'map' && isLaptopL) ? (
            <MobileFilter
              fetchData={fetchData}
              onDurationChange={handleDurationSelection}
              onWorkspaceHandler={onWorkspaceHandler}
            />
          ) : (
            <>
              <BudgetFilter fetchData={fetchData} />
              <WorkspaceFilter onWorkspaceHandler={onWorkspaceHandler} />
              <DurationFilter handleDurationSelection={handleDurationSelection} />
              <AllFilter fetchData={fetchData} />
            </>
          )}
        </div>
        <ViewToggle />
      </div>
    </div>
  );
};

export default observer(FiltersPanel);

